import React from 'react';
import PropTypes from 'prop-types';

import { Visible } from '@tfecom-thermofisher/react-komodo-design';

import './Divider.scss';

const Divider = ({ top, right, bottom, left }) => (
  <>
    <Visible when={top}>
      <div className="borderTop" />
    </Visible>

    <Visible when={right}>
      <div className="borderRight" />
    </Visible>

    <Visible when={bottom}>
      <div className="borderBottom" />
    </Visible>

    <Visible when={left}>
      <div className="borderLeft" />
    </Visible>
  </>
);

Divider.propTypes = {
  top: PropTypes.bool,
  right: PropTypes.bool,
  bottom: PropTypes.bool,
  left: PropTypes.bool
};

export default Divider;
